import { render, staticRenderFns } from "./createConversation.vue?vue&type=template&id=0481eaa3&"
import script from "./createConversation.vue?vue&type=script&lang=js&"
export * from "./createConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports